export const translations = {
    en: {
        dashboard: "Dashboard",
        sales: "Sales",
        addSale: "Add Sale",
        salesReturn: "Sales Return",
        saleReport: "Sale Report",
        products: "Products",
        addProduct: "Add Product",
        category: "Category",
        purchases: "Purchases",
        addPurchase: "Add Purchase",
        purchaseReturn: "Purchase Return",
        purchaseReport: "Purchase Report",
        suppliers: "Suppliers",
        customers: "Customers",
        expenses: "Expenses",
        expenseReport: "Expense Report",
        // Expenses
        addExpense: "Add Expense",
        expenseType: "Expense Type",
        expenseCost: "Cost",
        createExpense: "Create Expense",
        editExpense: "Edit Expense",
        // Reports
        downloadPDF: "Download PDF",
        downloadCSV: "Download CSV",
        downloadExcel: "Download Excel",
        print: "Print",
        period: "Period",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        yearly: "Yearly",
        startDate: "Start Date",
        endDate: "End Date",
        totalSales: "Total Sales",
        salesDetails: "Sales Details",
        totalCost: "Total Cost",
        balance: "Balance",
        grandTotal: "Grand Total",
        // Debts
        salesWithBalance: "Sales with Balance",
        phoneNumber: "Phone Number",
        saleReference: "Sale Reference",
        debts: "Debts",
        saleDetails: "Sale Details",
        sendReminder: "Send Reminder", income: "Income",
        pos: "POS",
        dailySales: "Daily Sales",
        monthlySales: "Monthly Sales",
        weeklySales: "Weekly Sales",
        netIncome: "Net Income",
        customerCount: "Total Customers",
        yearlyPurchases: "Yearly Purchases",
        monthlyExpenses: "Monthly Expenses",
        loading: "Loading...",
        cart: "CART",
        searchCustomer: "Search Customer",
        selectCustomer: "Select Customer",
        walkingCustomer: "Walking Customer",
        product: "Product",
        qty: "QTY",
        price: "Price",
        sellingPrice: "Selling Price",
        subTotal: "Sub Total",
        action: "Action",
        total: "Total",
        hold: "Hold",
        reset: "Reset",
        payNow: "Pay Now",
        scanSearch: "Scan/Search Product by Code Name",
        stock: "Stock",
        completeSale: "Complete Sale",
        datePaid: "Date Paid",
        amountPaid: "Amount Paid",
        paymentType: "Payment Type",
        submitSale: "Submit Sale",
        close: "Close",
        welcome: "Welcome",
        logout: "Logout",
        // Common
        description: "Description",
        status: "Status",
        dateAdded: "Date Added",
        actions: "Actions",
        edit: "Edit",
        delete: "Delete",
        view: "View",
        saveChanges: "Save Changes",
        cancel: "Cancel",
        create: "Create",
        search: "Search...",
        // Products
        productName: "Product Name",
        costPrice: "Cost Price",
        barcode: "Barcode",
        unitOfMeasurement: "Unit",
        quantityInStock: "Quantity in Stock",
        lowStock: "Low Stock!",
        inStock: "In Stock",
        outOfStock: "Out of Stock",
        productImage: "Product Image",
        noImage: "No Image",
        // Categories
        categoryName: "Category Name",
        createCategory: "Create Category",
        editCategory: "Edit Category",
        language: "Language",
        switchLanguage: "Ku Badal Af-Somali",
        // Authentications
        email: "Email Address",
        password: "Password",
        confirmPassword: "Confirm Password",
        login: "Login",
        loginWelcome: "To login, enter your email and password",
        forgotPassword: "Forgot Password?",
        register: "Register",
        pleaseRegister: "Please register",
        userType: "User Type",
        firstName: "First Name",
        lastName: "Last Name",
        submit: "Submit",
        branchName: "Branch Name",
        role: "Role",
        // Users
        userManagement: "User Management",
        unauthorizedAccess: "You don't have the right to view this page.",
        deleteUserConfirm: "Are you sure you want to delete this user?"
    },
    so: {
        dashboard: "Xog-ururin",
        sales: "Iibka",
        addSale: "Kudar Iib",
        salesReturn: "Soo Celinta Iibka",
        saleReport: "Warbixinta Iibka",
        products: "Badeecadaha",
        addProduct: "Kudar Badeecad",
        category: "Qeybaha",
        purchases: "Soo-iibsiga",
        addPurchase: "Kudar Iibsi",
        purchaseReturn: "Soo Celinta Iibsiga",
        purchaseReport: "Warbixinta Iibsiga",
        suppliers: "Alaab-qeybiyeyaasha",
        customers: "Macaamiisha",
        expenses: "Kharashaadka",
        expenseReport: "Warbixinta Kharashka",
        // Expenses
        addExpense: "Kudar Kharash",
        expenseType: "Nooca Kharashka",
        expenseCost: "Qiimaha",
        createExpense: "Abuur Kharash",
        editExpense: "Wax ka bedel Kharashka",
        // Reports
        downloadPDF: "Soo Dajiso PDF",
        downloadCSV: "Soo Dajiso CSV",
        downloadExcel: "Soo Dajiso Excel",
        print: "Daabac",
        period: "Muddada",
        daily: "Maalinle",
        weekly: "Toddobaadle",
        monthly: "Bille",
        yearly: "Sanadle",
        startDate: "Taariikhda Bilaabashada",
        endDate: "Taariikhda Dhamaadka",
        totalSales: "Wadarta Iibka",
        salesDetails: "Faahfaahinta Iibka",
        totalCost: "Wadarta Qiimaha",
        balance: "Haraaga",
        grandTotal: "Wadarta Guud",
        // Debts
        salesWithBalance: "Iibka leh Haraaga",
        phoneNumber: "Lambarka Tilifoonka",
        saleReference: "Tixraaca Iibka",
        debts: "Deymaha",
        saleDetails: "Faahfaahinta Iibka",
        sendReminder: "Dir Xasuusin", income: "Dakhliga",
        pos: "Goobta Iibka (POS)",
        dailySales: "Iibka Maalinlaha",
        monthlySales: "Iibka Bishii",
        weeklySales: "Iibka Todobaadkii",
        netIncome: "Faa'iidada Netka",
        customerCount: "Wadarta Macaamiisha",
        yearlyPurchases: "Iibsiga Sanadlaha",
        monthlyExpenses: "Kharashka Bishii",
        loading: "Soo kicinaya...",
        cart: "Gaariga Iibka",
        searchCustomer: "Raadi Macaamiil",
        selectCustomer: "Dooro Macaamiil",
        walkingCustomer: "Macaamiil Socda",
        product: "Badeecad",
        qty: "Tiro",
        price: "Qiimaha",
        sellingPrice: "Qiimaha Iibka",
        subTotal: "Wadarta Yar",
        action: "Ficil",
        total: "Wadarta",
        hold: "Hakad",
        reset: "Dib-u-dejin",
        payNow: "Bixi Hada",
        scanSearch: "Baar Badeecad (Code/Magac)",
        stock: "Keydka",
        completeSale: "Dhameystir Iibka",
        datePaid: "Taariikhda Bixinta",
        amountPaid: "Lacagta La Bixiyay",
        paymentType: "Nooca Bixinta",
        submitSale: "Gudbi Iibka",
        close: "Xir",
        welcome: "Soo Dhowow",
        logout: "Ka Bax",
        // Common
        description: "Faahfaahin",
        status: "Xaaladda",
        dateAdded: "Taariikhda Lagu Daray",
        actions: "Ficilada",
        edit: "Wax ka bedel",
        delete: "Tirtir",
        view: "Eeg",
        saveChanges: "Keydi Isbedelada",
        cancel: "Jooji",
        create: "Abuur",
        search: "Raadi...",
        // Products
        productName: "Magaca Badeecada",
        costPrice: "Qiimaha Gadashada",
        barcode: "Barcode-ka",
        unitOfMeasurement: "Halbeegga",
        quantityInStock: "Tirada Keydka",
        lowStock: "Keydka wuu yaraaday!",
        inStock: "Wuu yaalaa",
        outOfStock: "Wuu dhamaaday",
        productImage: "Sawirka Badeecada",
        noImage: "Sawir ma jiro",
        // Categories
        categoryName: "Magaca Qeybta",
        createCategory: "Abuur Qeyb",
        editCategory: "Wax ka bedel Qeybta",
        language: "Luqadda",
        switchLanguage: "Switch to English",
        // Authentications
        email: "Ciwaanka Email-ka",
        password: "Furaha Sirta",
        confirmPassword: "Xaqiiji Furaha Sirta",
        login: "Galitaanka",
        loginWelcome: "Si aad u gasho, gali email-kaaga iyo furahaaga sirta ah",
        forgotPassword: "Ilowday Furaha Sirta?",
        register: "Diiwaangeli",
        pleaseRegister: "Fadlan is-diiwaangeli",
        userType: "Nooca Isticmaalaha",
        firstName: "Magaca Koowaad",
        lastName: "Magaca Labaad",
        submit: "Gudbi",
        branchName: "Magaca Laanta",
        role: "Doorka",
        // Users
        userManagement: "Maamulka Isticmaaleyaas5ha",
        unauthorizedAccess: "Xaq uma lihid inaad aragto boggan.",
        deleteUserConfirm: "Ma hubtaa inaad rabto inaad tirtirto isticmaalahan?"
    }
};
